var charts={};
function chartInitiate(){
	var progressID = "si-progress-meter" 
	var $progressMeter = $("#si-progress-meter")
	var bar = new ProgressBar.Circle("#" + progressID, {
		strokeWidth: 8,
		easing: 'easeInOut',
		duration: 1400,
		trailWidth: 6,
		svgStyle: null,
		text: {
			style: {
				transform: null,
			},
			autoStyleContainer: false,
			
		},
		step: function(state, bar){
			return bar.setText(Math.round(bar.value()*100) + '% '+ $progressMeter.data("name"));
		}
	});
	charts[progressID] = bar;

}

////////*Feature:Progress Meter///////////////////////////////////////////////////////////////////////////////////////////////////////////////

function chartProgress() {
	var increments = Object.keys(slideCompletion).length
	for (slide in slideCompletion) {
		if (slideCompletion[slide] === 1 && chartProgressRecorded[slide] !== 1) {
			getPgr(increments)
			chartProgressRecorded[slide] = 1
		}
	}


}

function getPgr(increments) {
	var progressID = "si-progress-meter"
	var $progressMeter = $("#si-progress-meter")
	var x = parseFloat($progressMeter.attr('data-percent')) + 1 / increments;
	charts[progressID].animate(x);
	$progressMeter.attr('data-percent', x);
}